import React, {
	useContext,
	useRef,
} from 'react';
import Draggable from 'react-draggable';

import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { AVContext } from '../../contexts/audio-video';
import { GreenroomState as GRS } from '../../stores/types/types';
import useUserActions from '../../hooks/use-user-actions';

const smallIconSize = 14;
const bigIconSize = 18;

const cssClass = (isActive?: boolean, muted?: boolean) => classNames(
	muted ? 'padding-small' : 'padding-medium',
	isActive ? 'background-lighter' : 'background-red',
	'round',
	'text-white',
);

export default function AVUI() {
	const webrtcID = useSelector((s: GRS) => s.SessionReducer.webrtcID);
	const {
		debugAVUI,
	} = useSelector((state: GRS) => state.DebugReducer);

	const draggableRef = useRef<HTMLDivElement>(null);

	const { getAV } = useContext(AVContext);

	const { audio, video } = getAV();

	const { toggleVideo, toggleAudio } = useUserActions();

	const allMuted = !audio && !video;

	const iconSize = allMuted ? smallIconSize : bigIconSize;

	if (!debugAVUI) return null;

	return (<Draggable nodeRef={draggableRef}>
		<div ref={draggableRef} className='avui-debug-panel'>
			<div className={`avui-box ${allMuted ? 'allMuted' : ''}`}>
				<button
					className={cssClass(audio, allMuted)}
					onClick={(e) => {
						if (!webrtcID) return;
						toggleAudio();
						e.currentTarget.blur();
					}}
				>
					<Icon
						name={audio ? ICONS.MICROPHONE_ON : ICONS.MICROPHONE_OFF}
						color={COLORS.WHITE}
						size={iconSize}
					/>
				</button>
				<div className={`avui-dot ${allMuted ? ' allMuted' : ''}` }/>
				<button
					className={cssClass(video, allMuted)}
					onClick={(e) => {
						if (!webrtcID) return;
						toggleVideo();
						e.currentTarget.blur();
					}}
					style={{ marginLeft: allMuted ? '0.3rem' : '0.5rem' }}
				>
					<Icon
						name={video ? ICONS.CAMERA_ON : ICONS.CAMERA_OFF}
						color={COLORS.WHITE}
						size={iconSize}
					/>
				</button>
			</div>
		</div>
	</Draggable>);
}
